import { render } from "./NewBookByYear.vue?vue&type=template&id=687ce690&scoped=true"
import script from "./NewBookByYear.vue?vue&type=script&lang=js"
export * from "./NewBookByYear.vue?vue&type=script&lang=js"

import "./NewBookByYear.vue?vue&type=style&index=0&id=687ce690&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687ce690"]])

export default __exports__